module.exports = __webpack_public_path__ + "static/media/NrComanda.c90ce674.jpeg";